(() => {
  // cartページは既存ロジックが濃いため基本的に触らない（副作用・二重更新を避ける）
  // ※必要になれば後で条件を調整する
  const isCartPage = () => {
    try {
      const p = window.location.pathname || '';
      return p === '/cart' || p.startsWith('/cart/');
    } catch {
      return false;
    }
  };

  const ATTRIBUTE_KEY = 'Cart Item Count (Excluding Gift Wrapping)';

  function getGiftWrappingVariantId() {
    const v = window.giftWrappingVariantId;
    if (v === null || v === undefined || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }

  function calculateCount(cart) {
    const giftVariantId = getGiftWrappingVariantId();
    const itemCount = Number(cart?.item_count ?? 0) || 0;

    // giftWrappingVariantId が分からない場合は安全に item_count を使う（0固定問題の解消が主目的）
    if (!giftVariantId || !Array.isArray(cart?.items)) return itemCount;

    return cart.items.reduce((count, item) => {
      const qty = Number(item?.quantity ?? 0) || 0;
      const variantId = Number(item?.variant_id ?? 0) || 0;
      if (variantId !== giftVariantId) return count + qty;
      return count;
    }, 0);
  }

  function ensureCountBubble(container) {
    if (!container) return null;
    let bubble = container.querySelector('.cart-count-bubble');
    if (bubble) return bubble;

    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';

    const ariaHidden = document.createElement('span');
    ariaHidden.setAttribute('aria-hidden', 'true');

    const visuallyHidden = document.createElement('span');
    visuallyHidden.className = 'visually-hidden';

    bubble.appendChild(ariaHidden);
    bubble.appendChild(visuallyHidden);

    container.appendChild(bubble);
    return bubble;
  }

  function updateBubbleElement(bubble, count) {
    if (!bubble) return;
    const ariaHiddenSpan = bubble.querySelector('span[aria-hidden="true"]') || bubble.querySelector('span');
    const visuallyHiddenSpan = bubble.querySelector('.visually-hidden');

    if (count > 0) {
      if (ariaHiddenSpan) ariaHiddenSpan.textContent = String(count);
      if (visuallyHiddenSpan) visuallyHiddenSpan.textContent = String(count);
      bubble.style.display = '';
    } else {
      // 空カート時は Liquid と合わせて非表示（要素が存在する場合は消す）
      bubble.remove();
    }
  }

  function updateHeaderBubbles(count) {
    // まずはヘッダーの2箇所（PC/モバイル）を確実に更新する
    const desktopIcon = document.getElementById('cart-icon-bubble');
    const mobileIcon = document.getElementById('mobile-cart-icon-bubble');

    if (count > 0) {
      updateBubbleElement(ensureCountBubble(desktopIcon), count);
      updateBubbleElement(ensureCountBubble(mobileIcon), count);
    } else {
      // 0 の場合は両方ともバッジを消す
      if (desktopIcon) {
        const b = desktopIcon.querySelector('.cart-count-bubble');
        if (b) b.remove();
      }
      if (mobileIcon) {
        const b = mobileIcon.querySelector('.cart-count-bubble');
        if (b) b.remove();
      }
    }

    // 念のため、ページ内の他のバッジも（存在するものだけ）数字を揃える
    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      updateBubbleElement(bubble, count);
    });
  }

  async function updateCartAttributeIfNeeded(cart, desiredCount) {
    const currentRaw = cart?.attributes ? cart.attributes[ATTRIBUTE_KEY] : undefined;
    const current = currentRaw === undefined || currentRaw === null || currentRaw === ''
      ? null
      : Number(currentRaw);

    // "0" は Liquid の default に落ちず残留しやすいので、差分があれば上書きする
    if (Number.isFinite(current) && current === desiredCount) return;
    if (!Number.isFinite(desiredCount)) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        attributes: { [ATTRIBUTE_KEY]: String(desiredCount) },
      }),
    });
  }

  let inFlight = false;
  let pendingReason = null;

  async function syncNow(reason) {
    if (isCartPage()) return;
    if (inFlight) {
      pendingReason = reason || 'pending';
      return;
    }

    inFlight = true;
    try {
      const cart = await fetchCart();
      const desiredCount = calculateCount(cart);

      // DOMの表示は即時更新（体感を良くする）
      updateHeaderBubbles(desiredCount);

      // attributes は「差分がある時だけ」updateCartAttributeIfNeeded側で判定する
      await updateCartAttributeIfNeeded(cart, desiredCount);
    } catch (e) {
      // 失敗しても致命的にしない
      // eslint-disable-next-line no-console
      console.error('[cart-count-sync] sync failed', reason, e);
    } finally {
      inFlight = false;
      if (pendingReason) {
        const r = pendingReason;
        pendingReason = null;
        // 直後の連続呼び出しを吸収しつつ、最終状態に収束させる
        syncDebounced(`pending:${r}`);
      }
    }
  }

  let debounceTimer = null;
  function syncDebounced(reason) {
    if (debounceTimer) window.clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => syncNow(reason), 200);
  }

  function requestSyncWithRetry(reason) {
    // 1回目: なるべく早く反映
    syncDebounced(reason);
    // 2回目: add-to-cartのDOM置換や /cart.js の反映遅延に備えて追いかける
    window.setTimeout(() => syncDebounced(`${reason}:retry1`), 600);
    // 3回目: それでも遅い場合の保険（最終収束）
    window.setTimeout(() => syncDebounced(`${reason}:retry2`), 1500);
  }

  document.addEventListener('DOMContentLoaded', () => {
    // 初回ロード時に補正（attributes が "0" の残留を解消）
    requestSyncWithRetry('DOMContentLoaded');
  });

  // bfcache 戻りでも補正
  window.addEventListener('pageshow', () => {
    requestSyncWithRetry('pageshow');
  });

  // Dawn系の pubsub（cart-update）に追従
  try {
    // PUB_SUB_EVENTS は constants.js 側で const 定義のため window 直下に居ないことがある
    // subscribe は pubsub.js の関数（グローバル）を利用する
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS?.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        requestSyncWithRetry('pubsub:cartUpdate');
      });
    }
  } catch (e) {
    // noop
  }

  // 既存テーマが DOM イベントを使う場合にも追従（保険）
  ['cart:updated', 'cart:add', 'cart:change', 'cart:remove', 'cart:refresh'].forEach((evt) => {
    document.addEventListener(evt, () => requestSyncWithRetry(`dom:${evt}`));
  });
})();

